/**
 * IST (Asia/Kolkata) display helpers.
 *
 * STORAGE remains UTC — these helpers ONLY format for display.
 * Use these everywhere we render dates/times to the user (admin panel,
 * agent dashboard, B2C bookings, invoices, etc.) so India-based ops
 * staff see real local times instead of UTC offsets.
 */

const _IST = "Asia/Kolkata";

const _safe = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

/** "14 Feb 2026, 11:32 PM IST" */
export const fmtIST = (v) => {
  const d = _safe(v);
  if (!d) return "—";
  return d.toLocaleString("en-IN", {
    timeZone: _IST,
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  }) + " IST";
};

/** "14 Feb, 11:32 PM" — short form for cards/tables */
export const fmtISTShort = (v) => {
  const d = _safe(v);
  if (!d) return "—";
  return d.toLocaleString("en-IN", {
    timeZone: _IST,
    day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });
};

/** "11:32:14" — wall clock for live tickers */
export const fmtISTClock = (v) => {
  const d = _safe(v);
  if (!d) return "—";
  return d.toLocaleTimeString("en-IN", {
    timeZone: _IST,
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  });
};

/** "14 Feb 2026" — calendar-only (travel date / DOB) */
export const fmtISTDate = (v) => {
  const d = _safe(v);
  if (!d) return "—";
  return d.toLocaleDateString("en-IN", {
    timeZone: _IST,
    day: "2-digit", month: "short", year: "numeric",
  });
};

/** "2 hr 14 min ago" — relative tense */
export const fmtRelative = (v) => {
  const d = _safe(v);
  if (!d) return "—";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return `${Math.round(diff)} sec ago`;
  if (diff < 3600) return `${Math.round(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)} hr ago`;
  return `${Math.round(diff / 86400)} days ago`;
};
